var map = {
	"./prism-coy.css": 613,
	"./prism-coy.min.css": 614,
	"./prism-dark.css": 615,
	"./prism-dark.min.css": 616,
	"./prism-funky.css": 617,
	"./prism-funky.min.css": 618,
	"./prism-okaidia.css": 619,
	"./prism-okaidia.min.css": 620,
	"./prism-solarizedlight.css": 621,
	"./prism-solarizedlight.min.css": 622,
	"./prism-tomorrow.css": 623,
	"./prism-tomorrow.min.css": 624,
	"./prism-twilight.css": 625,
	"./prism-twilight.min.css": 626,
	"./prism.css": 627,
	"./prism.min.css": 628
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 612;